// extracted by mini-css-extract-plugin
export default {"Loader":"style_Loader__aHkrE","LoadingContent":"style_LoadingContent__HSGVQ"};